import React, { useEffect } from 'react';

const CoinContainer = () => {
    useEffect(() => {
        const container = document.getElementById("coin-container");

        const audio = new Audio("assets/acumuladoCoin.mp3");
        audio.loop = true;
        const playPromise = audio.play();
        if (playPromise !== undefined) {
            playPromise
                .then(() => {
                    // Audio playback started
                })
                .catch((error) => {
                    console.warn("Audio playback was prevented:", error);
                });
        }
        const createCoin = () => {
            const coin = document.createElement("div");
            coin.className = "coin";

            coin.style.left = `${Math.random() * 100}vw`;
            const duration = 1 + Math.random(); // 1 to 2 sec
            const delay = Math.random(); // 0 to 1 sec

            coin.style.animationDuration = `${duration}s`;
            coin.style.animationDelay = `${delay}s`;

            container.appendChild(coin);

            setTimeout(() => {
                coin.remove();
            }, (duration + delay) * 1000);
        };

        const interval = setInterval(createCoin, 30);

        return () => {
            clearInterval(interval);
            if (!audio.paused) {
                audio.pause();
                audio.currentTime = 0;
            }
        };
    }, []);

    return (
        <div className="coinContainer-div">
            <div id="coin-container"></div>
        </div>
    );
};

export default CoinContainer;
